module.exports = __webpack_public_path__ + "img/aboutTMIP.0a9a085a.jpg";